function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "icon/user-friends",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.6,10.7 C8.7278125,10.7 10.45,8.9778125 10.45,6.85 C10.45,4.7221875 8.7278125,3 6.6,3 C4.4721875,3 2.75,4.7221875 2.75,6.85 C2.75,8.9778125 4.4721875,10.7 6.6,10.7 Z M9.24,11.8 L8.9546875,11.8 C8.2396875,12.14375 7.445625,12.35 6.6,12.35 C5.754375,12.35 4.96375,12.14375 4.2453125,11.8 L3.96,11.8 C1.77375,11.8 0,13.57375 0,15.76 L0,16.75 C0,17.6609375 0.7390625,18.4 1.65,18.4 L11.55,18.4 C12.4609375,18.4 13.2,17.6609375 13.2,16.75 L13.2,15.76 C13.2,13.57375 11.42625,11.8 9.24,11.8 Z M16.5,10.7 C18.321875,10.7 19.8,9.221875 19.8,7.4 C19.8,5.578125 18.321875,4.1 16.5,4.1 C14.678125,4.1 13.2,5.578125 13.2,7.4 C13.2,9.221875 14.678125,10.7 16.5,10.7 Z M18.15,11.8 L18.019375,11.8 C17.5415625,11.965 17.03625,12.075 16.5,12.075 C15.96375,12.075 15.4584375,11.965 14.980625,11.8 L14.85,11.8 C14.14875,11.8 13.5025,12.0028125 12.9353125,12.329375 C13.7740625,13.2334375 14.3,14.433125 14.3,15.76 L14.3,17.08 C14.3,17.155625 14.2828125,17.2278125 14.279375,17.3 L20.35,17.3 C21.2609375,17.3 22,16.5609375 22,15.65 C22,13.5221875 20.2778125,11.8 18.15,11.8 L18.15,11.8 Z",
  id: "Shape",
  fill: "#FEFEFE",
  fillRule: "nonzero"
}));

function SvgUserFriends(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/user-friends") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserFriends);
export default __webpack_public_path__ + "static/media/user-friends.8037f32e.svg";
export { ForwardRef as ReactComponent };